module.exports = __webpack_public_path__ + "img/Randtrümmer.91d2e9ab.svg";